import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect, useContext, useState } from 'react';
import { connect } from 'react-redux';
import StaticCard from '../../components/static/StaticCard';
import { trackPage } from '../../helpers/analytics';
import { getAnchorFromUrl, getStaticContent } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import { getServerSideEssentials } from '../../redux/actions/ssr';
import { wrapper } from '../../redux/store/store';

const Post = ({ errorCode, text }) => {
  const theme = useContext(ThemeContext);
  const [pageNotFound, setPageNotFound] = useState(false);
  const router = useRouter();
  const anchorName = getAnchorFromUrl(router.asPath);

  if (anchorName) {
    setTimeout(() => {
      // we need to set a timeout because the static pages take time to be displayed
      const anchor = document.getElementById(anchorName);
      if (anchor) {
        anchor.scrollIntoView();
      }
    }, 1_000);
  }

  useEffect(() => {
    if (errorCode && document) {
      setPageNotFound(true);
    }
  }, [errorCode]);

  if (pageNotFound) {
    trackPage('static_page_404');
    // Import only if needed
    const DynamicComponent = dynamic(() =>
      import('../../components/errors/Form404'),
    );

    return <DynamicComponent statusCode={404} />;
  }

  return (
    <div className="container">
      <StaticCard text={text} />
      <style jsx>{`
        .container {
          margin-top: 12px;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .container {
            margin-top: 20px;
            margin-bottom: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  async (context) => {
    const { req, store } = context;
    await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
      console.log(`getServerSideEssentials error: ${error}`);
    });

    return getStaticContent({ context });
  },
);

export default connect()(Post);
